import { render, staticRenderFns } from "./OrderFormStep6SecularNameTab.module.vue?vue&type=template&id=a9c0339c&scoped=true&"
import script from "./OrderFormStep6SecularNameTab.module.vue?vue&type=script&lang=js&"
export * from "./OrderFormStep6SecularNameTab.module.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormStep6SecularNameTab.module.vue?vue&type=style&index=0&id=a9c0339c&lang=scss&scoped=true&"
import style1 from "./OrderFormStep6SecularNameTab.module.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c0339c",
  null
  
)

export default component.exports